import { cuid } from '@triade/contracts';

/**
 * Busca da rota /precificar/simulador (Sessao 28).
 * - sem nada: lista dos cenarios salvos;
 * - `cenario=<id>`: abre o cenario salvo;
 * - `novo=1`: simulador em branco.
 */
export interface BuscaSimulador {
  cenario?: string;
  novo?: 1;
}

/** Id de cenario so passa se for um id seguro (mesma regra do contrato). Qualquer outra coisa e ignorada. */
export function lerBuscaSimulador(bruto: Record<string, unknown>): BuscaSimulador {
  const cenario = typeof bruto.cenario === 'string' && cuid.safeParse(bruto.cenario).success ? bruto.cenario : undefined;
  const novo = bruto.novo === 1 || bruto.novo === '1' ? 1 : undefined;
  return {
    ...(cenario !== undefined ? { cenario } : {}),
    ...(novo !== undefined && cenario === undefined ? { novo } : {}),
  };
}
